import { AUTH_COOKIE } from '@web/libs/constants'
import { clearMobileCacheStorage } from '@web/libs/utils'

import useCookieChange from './useCookieChange'

const useGlobalAuthCookieChange = () => {
  useCookieChange({ onChange: clearMobileCacheStorage, key: AUTH_COOKIE.NID_AUT })
  useCookieChange({ onChange: clearMobileCacheStorage, key: AUTH_COOKIE.NID_SES })
}

export default useGlobalAuthCookieChange
